import { render, staticRenderFns } from "./eyeDiagnosis.vue?vue&type=template&id=63a04e72&scoped=true&"
import script from "./eyeDiagnosis.vue?vue&type=script&lang=js&"
export * from "./eyeDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./eyeDiagnosis.vue?vue&type=style&index=0&id=63a04e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a04e72",
  null
  
)

export default component.exports